import { render } from "./webhook.vue?vue&type=template&id=0bd9a354"
import script from "./webhook.vue?vue&type=script&lang=js"
export * from "./webhook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__